import { Moment } from "moment";
import CheckpointAtivo from "./checkpointAtivo";

export default class Checkpoint implements ICheckpoint {
  public data!: Moment;
  public posicoes!: CheckpointAtivo[];

  constructor(param: ICheckpoint) {
    Object.assign(this, param);
  }
}

interface ICheckpoint {
  data: Moment;
  posicoes: CheckpointAtivo[];
}
